module.exports = __webpack_public_path__ + "static/media/TX24.0593e56b.jpg";